import Vue from 'vue'
import router from './router'
import { store } from './store/store'
import App from './App.vue'
// global components

window.Vue = Vue;

// navigation guards before each
router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requiresAuth)) {
		next()
	} else {
        next()
		//
	}
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js